import { toast } from "react-toastify";
import { objectToText } from "./commonHelpers";

// TODO: Work with backend to make error messages consistent and remove this function
function handleFormErrors(message: any): string {
  if (message.message)
    if (Array.isArray(message.message)) {
      const [errMsg] = message.message;
      message.message = errMsg;
    } else {
      message.message = message.message.charAt(0).toUpperCase() + message.message.slice(1).replace(/_/g, " ");
    }
  if (message.title) message.title = message.title.charAt(0).toUpperCase() + message.title.slice(1).replace(/_/g, " ");
  if (typeof message === "object") {
    if (message.title || message.type) return `${message.title || message.type}: ${message.message} `;
    // Nested row errors come back with `{}` for rows that have no errors.
    const firstEntry = Object.entries(message)[0];
    if (!firstEntry) return "";
    const [title, msg] = firstEntry;
    if (Array.isArray(msg)) {
      const { title, message } = msg?.[0] ?? {};
      if (title) return `${title}: ${message || "Something went wrong"}`;
    }
    return `${title.charAt(0).toUpperCase() + title.slice(1).replace(/_/g, " ")}: ${msg} `;
  }
  return message;
}

function errorToast(error: any, fallbackMessage?: string): void | string[] {
  const { response } = error || {};
  const customMessage = fallbackMessage || "Something went wrong. Please try again later";

  if (!response) {
    toast.error(customMessage);
    return;
  }

  const { data } = response;
  let errorMessages: string[] = [];

  // check if data is an object with arrays. If the key is detail, we don't show the key. If it's a specific key, we show key: message in the toast.
  if (typeof data === "object" && !Array.isArray(data)) {
    Object.entries(data).forEach(([key, value]: any) => {
      const capitalizedKey = key === "detail" ? "" : `${key.charAt(0).toUpperCase()}${key.slice(1)}: `;
      if (Array.isArray(value)) {
        errorMessages = [
          ...errorMessages,
          ...value.map((message) => {
            if (typeof message === "string") return `${capitalizedKey}${message}`;
            return handleFormErrors(message);
          }),
        ];
      } else if (typeof value === "string") {
        errorMessages.push(`${capitalizedKey}${value}`);
      } else if (typeof value === "object") {
        if (typeof value?.[0]?.[0] === "string") {
          errorMessages.push(value["0"][0]);
        } else {
          Object.entries(value).forEach(([subKey, val]: any) => {
            if (Array.isArray(val)) {
              errorMessages = [
                ...errorMessages,
                ...val.map((message: any) => {
                  if (typeof message === "string") return `${capitalizedKey}${message}`;
                  const formError = handleFormErrors(message);
                  return formError && `${capitalizedKey} ${formError}`;
                }),
              ];
            } else if (typeof val === "object") {
              errorMessages.push(`${capitalizedKey} ${subKey}: ${objectToText(val)}`);
            } else if (typeof val === "string") {
              errorMessages.push(`${capitalizedKey} ${subKey}: ${val}`);
            }
          });
        }
      }
    });
  } else if (Array.isArray(data) && data.every((item) => typeof item === "string")) {
    errorMessages.push(...data);
  }

  errorMessages = errorMessages.filter((message) => message.trim());

  if (errorMessages.length) {
    errorMessages = errorMessages.map((message) => message.replace(/stop1/gi, "Delivery"));
    toast.error(
      <ul>
        {errorMessages.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>,
    );
    return errorMessages;
  }
  toast.error(customMessage);
}

export default errorToast;
